var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 182,
    height: 67.112,
    viewBox: "0 0 182 67.112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182,
    height: 67.112,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Cuadr\\xEDcula_de_repetici\\xF3n_1",
    "data-name": "Cuadr\\xEDcula de repetici\\xF3n 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1",
    "data-name": "Grupo 1",
    transform: "translate(-376.561 -265.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1-2",
    "data-name": "Grupo 1",
    transform: "translate(376.561 265.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1",
    "data-name": "Trazado 1",
    d: "M655.475,359.666",
    transform: "translate(-572.649 -331.554)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2",
    "data-name": "Trazado 2",
    d: "M647.655,360.9",
    transform: "translate(-567.151 -332.423)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M385.337,278.9l-1.082,3h-7.693l0-.186h.235a1.188,1.188,0,0,0,1.188-1.167V270.262A1.188,1.188,0,0,0,376.8,269.1h-.235l0-.186h4.06l0,.186h-.235a1.189,1.189,0,0,0-1.189,1.167v11.069h2.661c1.967,0,2.722-1.017,3.295-2.43Z",
    transform: "translate(-376.561 -267.749)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_4",
    "data-name": "Trazado 4",
    d: "M408.412,338.257l-.335,4.308a8.495,8.495,0,0,1-7.712,4.087c-5.739-.028-9.8-3.952-9.8-10.017,0-5.955,3.925-9.962,9.962-9.962a11.723,11.723,0,0,1,6.491,1.853l.554,3.876h-.228c-.834-3.2-3.523-4.906-6.822-4.907-4.824,0-7.9,3.65-7.9,9.111,0,5.516,3.129,9.111,7.743,9.223,3.9-.011,7.194-1.952,7.817-7.572Z",
    transform: "translate(-386.406 -308.359)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5",
    "data-name": "Trazado 5",
    d: "M530.838,327.964c3.509,0,5.66,2.014,5.66,5.3a5.388,5.388,0,0,1-7.985,4.6l0-.259s4.515.974,5.752-2.957a5.676,5.676,0,0,0,.176-1.656c-.068-2.521-1.364-4.2-3.7-4.2h-3.164v16.387a1.759,1.759,0,0,0,1.758,1.726h.348l0,.274h-6.008l0-.274h.347a1.76,1.76,0,0,0,1.758-1.726V329.818a1.758,1.758,0,0,0-1.749-1.582h-.347l-.005-.273Z",
    transform: "translate(-479.99 -309.266)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_6",
    "data-name": "Trazado 6",
    d: "M587.918,345.992H576.541l0-.275h.347a1.758,1.758,0,0,0,1.758-1.725V328.625a1.758,1.758,0,0,0-1.749-1.572h-.347l0-.273h8.019a11.849,11.849,0,0,0,3.272-.5v3.466l-.277,0v-.489a1.637,1.637,0,0,0-1.537-1.633h-5.594V336.1h4.638a1.352,1.352,0,0,0,1.327-1.352v-.4l.268,0v4.343l-.268,0v-.4a1.353,1.353,0,0,0-1.3-1.352h-4.666v8.223h3.936c2.908,0,4.024-1.5,4.872-3.594h.274Z",
    transform: "translate(-517.155 -308.083)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7",
    "data-name": "Trazado 7",
    d: "M636.328,327.961c3.326,0,5.364,1.96,5.364,5.158,0,2.657-2.023,5.233-4.661,5.233a6.648,6.648,0,0,1,1.964,1.931s2.365,3.378,3.429,4.539c1.1,1.206,2.119,2.062,3.732,2.075v.275h-1.507a5.905,5.905,0,0,1-4.788-2.406c-.311-.372-3.4-4.872-3.615-5.137-.717-.9-1.518-1.852-2.52-1.852v-.254s.623.013,1.45-.009c1.424-.039,3.505-.378,4.283-2.85a5.694,5.694,0,0,0,.176-1.643c-.068-2.482-1.362-4.072-3.4-4.184-1.4-.077-3.06-.009-3.416-.021v16.357a1.758,1.758,0,0,0,1.757,1.726h.348l0,.274h-6l0-.274h.347a1.758,1.758,0,0,0,1.757-1.712V329.96a1.758,1.758,0,0,0-1.758-1.725h-.347l0-.273Z",
    transform: "translate(-553.984 -309.265)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_8",
    "data-name": "Trazado 8",
    d: "M704.742,327.963v.275H704.3a1.4,1.4,0,0,0-1.45,1.3v10.852c0,4.3-2.959,7.172-7.4,7.172-4.566,0-7.61-2.85-7.61-7.124V329.6a1.4,1.4,0,0,0-1.452-1.359h-.446v-.275h5.574v.275h-.448a1.394,1.394,0,0,0-1.448,1.318v10.476c0,4,2.331,6.663,5.827,6.663,3.667,0,6.111-2.524,6.117-6.309V329.559a1.4,1.4,0,0,0-1.45-1.321h-.448v-.275Z",
    transform: "translate(-594.067 -309.266)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_9",
    "data-name": "Trazado 9",
    d: "M774.116,338.257l-.335,4.308a8.495,8.495,0,0,1-7.712,4.087c-5.739-.028-9.8-3.952-9.8-10.017,0-5.955,3.925-9.962,9.962-9.962a11.723,11.723,0,0,1,6.491,1.853l.554,3.876h-.228c-.834-3.2-3.524-4.906-6.822-4.907-4.824,0-7.9,3.65-7.9,9.111,0,5.516,3.129,9.111,7.744,9.223,3.9-.011,7.194-1.952,7.817-7.572Z",
    transform: "translate(-643.511 -308.359)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_10",
    "data-name": "Trazado 10",
    d: "M830.294,347.168h-6l0-.274h.347a1.758,1.758,0,0,0,1.758-1.726V329.944a1.757,1.757,0,0,0-1.757-1.714h-.348l0-.275h6l0,.275h-.348a1.758,1.758,0,0,0-1.757,1.708v15.23a1.758,1.758,0,0,0,1.757,1.726h.348Z",
    transform: "translate(-691.333 -309.26)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_11",
    "data-name": "Trazado 11",
    d: "M864.4,326.69a11.9,11.9,0,0,0,3.306-.5v3.45l-.277,0v-.489a1.635,1.635,0,0,0-1.564-1.634h-5.2V343.95a1.758,1.758,0,0,0,1.756,1.7h.347l0,.274h-6.008l0-.274h.348a1.759,1.759,0,0,0,1.756-1.682v-16.46h-5.205a1.636,1.636,0,0,0-1.565,1.634v.489l-.276,0v-3.45a11.893,11.893,0,0,0,3.306.5Z",
    transform: "translate(-710.691 -308.02)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_12",
    "data-name": "Trazado 12",
    d: "M927.382,348.711c-4.325,1.591-8.7-1.043-11.482-9.264l-1.063-3.141H907.31l-1.9,4.894a1.168,1.168,0,0,0,1.044,1.723h.241v.272H901.17v-.274h.247a2.682,2.682,0,0,0,2.333-1.581l6.8-16.316c-1.191-1.7-2.937-2.718-5.779-1.69l-.077-.277c6.429-2.723,8.355,2.532,9.72,6.395l3.348,9.485c1.549,4.4,4.613,10.571,9.6,9.5Zm-12.823-13.227-2.168-6.4a22.613,22.613,0,0,0-1.148-2.877l-3.613,9.278Z",
    transform: "translate(-745.382 -305.287)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_13",
    "data-name": "Trazado 13",
    d: "M444.905,308.146c-4.99,1.071-8.056-5.107-9.605-9.505l-3.35-9.489c-1.322-3.747-3.174-8.8-9.151-6.623h0l-.01,0q-.16.058-.323.124a2.166,2.166,0,0,1-.415.1l-.129.006h-.008c-2.978.075-4.843-3.739-5.819-6.509l-2.265-6.416c-.923-2.613-2.226-6.168-6.576-4.326l.052.188a3.02,3.02,0,0,1,3.909,1.144l-4.6,11.038a1.815,1.815,0,0,1-1.579,1.069h-.167v.185h3.737v-.184h-.163a.79.79,0,0,1-.706-1.166l1.286-3.31h5.092l.72,2.125c1.781,5.257,4.521,7.136,7.286,6.418v0a13.988,13.988,0,0,1,1.876-.377v0a4.3,4.3,0,0,1,4.084,2.086l-6.8,16.323a2.684,2.684,0,0,1-2.335,1.582H418.7v.274h5.526v-.272h-.241a1.167,1.167,0,0,1-1.043-1.724l1.9-4.9h7.531l1.064,3.142c2.786,8.224,7.16,10.86,11.486,9.268Zm-35.661-34.228,2.444-6.277a15.246,15.246,0,0,1,.776,1.946l1.467,4.331Zm15.924,21.269,3.613-9.282a22.283,22.283,0,0,1,1.149,2.878l2.168,6.4Z",
    transform: "translate(-396.466 -265.001)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_14",
    "data-name": "Trazado 14",
    d: "M677.056,417.172c-.385-1.969.805-5.345,5.328-5.345a7.315,7.315,0,0,1,7.488,7.64c0,4.826-3.7,8.115-8.721,8.115-4.978,0-8.787-3.246-8.787-8.094a7.44,7.44,0,0,1,4.175-6.921l.129.2c-2.032,1.337-2.638,4.15-2.638,6.4,0,5.021,3.094,7.769,7.077,7.769,4.155,0,7.1-2.987,7.1-7.51,0-3.636-1.991-6.947-5.994-6.947-3.594,0-5.26,2.684-4.939,4.652Z",
    transform: "translate(-584.522 -368.226)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15",
    "data-name": "Trazado 15",
    d: "M745.593,413.256c4.249,0,6.583,2.03,6.593,5.067a4.626,4.626,0,0,1-3.359,4.6,5.751,5.751,0,0,1,5.194,5.846c0,3.423-2.546,5.7-7.062,5.7h-7.385l.005-.3h.383a1.942,1.942,0,0,0,1.941-1.886V415.438a1.921,1.921,0,0,0-1.946-1.881h-.378l-.005-.3Zm1.261,20.109c3.11.015,4.9-1.743,4.895-4.808,0-4.542-3.906-5.3-6.839-5.294l-.007-.285c1.849.007,5-.539,5.012-4.436-.012-2.74-1.558-4.315-4.431-4.312h-1.6v19.135Z",
    transform: "translate(-631.775 -369.23)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_16",
    "data-name": "Trazado 16",
    d: "M805.909,419.311c-.541-2.756,1.126-7.484,7.461-7.484,6.3,0,10.484,4.728,10.484,10.7,0,6.758-5.182,11.364-12.213,11.364-6.97,0-12.3-4.546-12.3-11.334a10.418,10.418,0,0,1,5.845-9.691l.182.273c-2.846,1.872-3.695,5.812-3.695,8.964,0,7.031,4.334,10.88,9.911,10.88,5.818,0,9.94-4.182,9.94-10.516,0-5.091-2.788-9.728-8.395-9.728-5.031,0-7.364,3.758-6.915,6.514Z",
    transform: "translate(-673.79 -368.226)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_17",
    "data-name": "Trazado 17",
    d: "M655.168,431.532c-3.466,2.469-6.018,3.147-13.819,2.748l.013-.035-.083.034c-1.423-.058-4.752-.6-6.835-.662h-1.466v-18.1a1.944,1.944,0,0,1,1.945-1.908h.384l0-.3h-6.64l.005.3h.384A1.944,1.944,0,0,1,631,415.515v16.819a1.943,1.943,0,0,1-1.942,1.908h-.384l-.005.3h4.269a22.793,22.793,0,0,1,2.352.281c6.332,1.046,13.832,4.119,20.075-3.105Z",
    transform: "translate(-553.805 -369.264)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_18",
    "data-name": "Trazado 18",
    d: "M496.755,426.5v.186h-.26a2.4,2.4,0,0,0-1.862,1.078l-3.669,5.932v4.443a1.189,1.189,0,0,0,1.188,1.167h.234l0,.186h-4.06l0-.186h.235a1.19,1.19,0,0,0,1.188-1.156v-4.473l-3.533-5.907a2.344,2.344,0,0,0-1.866-1.084h-.253V426.5h4.564v.185h-.234a.783.783,0,0,0-.65,1.152l2.78,5.193,2.957-5.2.01-.017a.783.783,0,0,0-.66-1.133h-.234V426.5Z",
    transform: "translate(-452.169 -378.54)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_19",
    "data-name": "Trazado 19",
    d: "M552.665,438.69h-7.694l0-.186h.234a1.189,1.189,0,0,0,1.189-1.167V426.947a1.189,1.189,0,0,0-1.183-1.063h-.234l0-.184H550.4a8.007,8.007,0,0,0,2.212-.338v2.343l-.187,0v-.33a1.107,1.107,0,0,0-1.039-1.1H547.6V432h3.136a.914.914,0,0,0,.9-.914v-.273l.182,0v2.937l-.182,0v-.274a.915.915,0,0,0-.878-.914H547.6v5.56h2.661c1.967,0,2.721-1.017,3.294-2.43h.185Z",
    transform: "translate(-494.96 -377.741)",
    fill: "#040006"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_20",
    "data-name": "Trazado 20",
    d: "M589.171,436.494l-1.082,3H580.4l0-.186h.235a1.189,1.189,0,0,0,1.188-1.167V427.855a1.189,1.189,0,0,0-1.188-1.167H580.4l0-.186h4.06l0,.186h-.235a1.189,1.189,0,0,0-1.189,1.167v11.069h2.661c1.967,0,2.722-1.017,3.295-2.43Z",
    transform: "translate(-519.865 -378.543)",
    fill: "#040006"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2",
    "data-name": "Grupo 2",
    transform: "translate(451.657 268.398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_21",
    "data-name": "Trazado 21",
    d: "M629.443,282.6v-5.884q.785-.057,1.314-.058a2.159,2.159,0,0,1,1.388.434,1.477,1.477,0,0,1,.545,1.227,1.746,1.746,0,0,1-.314,1,2.815,2.815,0,0,1-.7.736q.306.421.756,1t.583.731a1.836,1.836,0,0,0,1.14.611l-.008.265a2.056,2.056,0,0,1-.818-.153,1.987,1.987,0,0,1-.6-.442q-.285-.3-1.417-1.851-.81,0-1.471-.049V282.6Zm1.628-2.71a1.113,1.113,0,0,0,.777-.48,1.65,1.65,0,0,0,.413-1.112,1.134,1.134,0,0,0-.425-.959,1.806,1.806,0,0,0-1.128-.326q-.372,0-.868.033v2.8Q630.5,279.894,631.071,279.895Z",
    transform: "translate(-629.443 -276.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_22",
    "data-name": "Trazado 22",
    d: "M658.885,282.684v-5.909h2.744v.347h-2.347V279.3h2.124v.339h-2.124v2.7h2.438v.347Z",
    transform: "translate(-650.142 -276.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_23",
    "data-name": "Trazado 23",
    d: "M685.991,277.061a3.05,3.05,0,0,0-1.2-.256q-1.206,0-1.206.893a1.122,1.122,0,0,0,.273.723,2.98,2.98,0,0,0,.661.6q.388.26.777.533a2.765,2.765,0,0,1,.661.653,1.391,1.391,0,0,1,.273.827,1.34,1.34,0,0,1-.5,1.136,2.248,2.248,0,0,1-1.392.384,2.515,2.515,0,0,1-1.516-.455l.2-.3a2.34,2.34,0,0,0,1.306.388,1.794,1.794,0,0,0,1.091-.285.965.965,0,0,0,.38-.823,1.1,1.1,0,0,0-.272-.706,3.176,3.176,0,0,0-.661-.6q-.388-.269-.777-.55a2.819,2.819,0,0,1-.661-.669,1.425,1.425,0,0,1-.273-.835,1.122,1.122,0,0,1,.434-.929,1.84,1.84,0,0,1,1.173-.343,3.214,3.214,0,0,1,1.376.3Z",
    transform: "translate(-666.968 -276.441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_24",
    "data-name": "Trazado 24",
    d: "M710.2,277.122h-2v-.347h4.4v.347h-2v5.562h-.4Z",
    transform: "translate(-684.81 -276.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_25",
    "data-name": "Trazado 25",
    d: "M734.348,280.536l-.851,2.049h-.422l2.488-5.95h.231l2.5,5.95h-.446l-.851-2.049Zm1.306-3.24a.437.437,0,0,0-.033.1q-.116.355-.223.6l-.909,2.2h2.364l-.909-2.19A3.993,3.993,0,0,1,735.654,277.3Z",
    transform: "translate(-702.3 -276.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_26",
    "data-name": "Trazado 26",
    d: "M768.989,282.109a2.572,2.572,0,0,1-3.475,0,2.772,2.772,0,0,1-.574-1.851v-3.479h.4v3.479q0,2.181,1.913,2.181t1.913-2.181v-3.479h.4v3.479A2.782,2.782,0,0,1,768.989,282.109Z",
    transform: "translate(-724.703 -276.676)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27",
    "data-name": "Trazado 27",
    d: "M798.751,282.6v-5.884q.785-.057,1.314-.058a2.16,2.16,0,0,1,1.389.434,1.477,1.477,0,0,1,.545,1.227,1.744,1.744,0,0,1-.314,1,2.813,2.813,0,0,1-.7.736q.306.421.756,1t.582.731a1.838,1.838,0,0,0,1.141.611l-.008.265a2.057,2.057,0,0,1-.818-.153,1.994,1.994,0,0,1-.6-.442q-.285-.3-1.417-1.851-.81,0-1.471-.049V282.6Zm1.628-2.71a1.113,1.113,0,0,0,.777-.48,1.651,1.651,0,0,0,.413-1.112,1.134,1.134,0,0,0-.425-.959,1.806,1.806,0,0,0-1.128-.326q-.372,0-.868.033v2.8Q799.809,279.894,800.379,279.895Z",
    transform: "translate(-748.473 -276.597)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_28",
    "data-name": "Trazado 28",
    d: "M826.238,280.536l-.851,2.049h-.421l2.488-5.95h.231l2.5,5.95h-.447l-.851-2.049Zm1.305-3.24a.484.484,0,0,0-.033.1q-.116.355-.223.6l-.909,2.2h2.364l-.909-2.19A3.977,3.977,0,0,1,827.543,277.3Z",
    transform: "translate(-766.903 -276.577)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_29",
    "data-name": "Trazado 29",
    d: "M858.154,277.6l.017.7v4.264h-.4v-5.959h.182l3.892,4.487q.4.471.611.752-.033-.4-.033-.909v-4.281h.4v5.958h-.182l-3.967-4.57q-.414-.471-.529-.628Z",
    transform: "translate(-789.969 -276.558)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_30",
    "data-name": "Trazado 30",
    d: "M892.194,277.122h-2v-.347h4.4v.347h-2v5.562h-.4Z",
    transform: "translate(-812.762 -276.676)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlack);
export default __webpack_public_path__ + "static/media/logo-black.ab9a13107b9a7764f6eb87ca215b8e68.svg";
export { ForwardRef as ReactComponent };